import config from '../config';
import selectedEnvironment from '../env';
const API_URL = `${config[selectedEnvironment].API_URL}`;

const authHeaders = (auth, json = false) => ({
    Authorization: 'Bearer ' + auth,
    ...(json ? { 'Content-Type': 'application/json' } : {}),
});

// Parses the JSON body and throws the server's { error } message on non-2xx responses.
const handleResponse = async (response) => {
    const text = await response.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        data = null;
    }
    if (!response.ok) {
        const message = data?.error || data?.message || data?.title || text || `Request failed (${response.status})`;
        const err = new Error(message);
        err.status = response.status;
        throw err;
    }
    return data;
};

// Returns { caseId, hasCredentials, clientId, environment, hasSecret, lastTestedAt, lastTestOk, lastTestMessage, updatedAt }.
// The secret itself is never returned.
const GetCredentials = async (caseId, auth) => {
    const response = await fetch(`${API_URL}/MorningApi/credentials/${encodeURIComponent(caseId)}`, {
        method: 'GET',
        headers: authHeaders(auth),
    });
    return handleResponse(response);
};

// clientSecret may be empty when updating; the stored secret is kept.
const SaveCredentials = async ({ caseId, clientId, clientSecret, environment }, auth) => {
    const response = await fetch(`${API_URL}/MorningApi/credentials`, {
        method: 'PUT',
        headers: authHeaders(auth, true),
        body: JSON.stringify({
            CaseId: caseId,
            ClientId: clientId,
            ClientSecret: clientSecret || null,
            Environment: environment || 'Live',
        }),
    });
    return handleResponse(response);
};

const DeleteCredentials = async (caseId, auth) => {
    const response = await fetch(`${API_URL}/MorningApi/credentials/${encodeURIComponent(caseId)}`, {
        method: 'DELETE',
        headers: authHeaders(auth),
    });
    return handleResponse(response);
};

// Returns { success, message }.
const TestCredentials = async (caseId, auth) => {
    const response = await fetch(`${API_URL}/MorningApi/credentials/${encodeURIComponent(caseId)}/test`, {
        method: 'POST',
        headers: authHeaders(auth),
    });
    return handleResponse(response);
};

const buildImportBody = (request) => ({
    CaseId: request.caseId,
    FromDate: request.fromDate || null,
    ToDate: request.toDate || null,
    SortCodeId: request.sortCodeId || null,
    DefaultAccountId: request.defaultAccountId || null,
    PaymentTypeToCardId: request.paymentTypeToCardId || null,
    ClassificationToCardId: request.classificationToCardId || null,
    DownloadDocuments: !!request.downloadDocuments,
});

// kind: 'clients' | 'suppliers' | 'incomes' | 'payments' | 'expenses'
const Preview = async (kind, request, auth) => {
    const response = await fetch(`${API_URL}/MorningApi/preview/${encodeURIComponent(kind)}`, {
        method: 'POST',
        headers: authHeaders(auth, true),
        body: JSON.stringify(buildImportBody(request)),
    });
    return handleResponse(response);
};

// kind: 'clients' | 'suppliers' | 'incomes' | 'payments' | 'expenses'
const Import = async (kind, request, auth) => {
    const response = await fetch(`${API_URL}/MorningApi/import/${encodeURIComponent(kind)}`, {
        method: 'POST',
        headers: authHeaders(auth, true),
        body: JSON.stringify(buildImportBody(request)),
    });
    return handleResponse(response);
};

const MorningApiService = {
    GetCredentials,
    SaveCredentials,
    DeleteCredentials,
    TestCredentials,
    Preview,
    Import,
};

export default MorningApiService;
